new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        const faixCupom = document.querySelector('.faixa-cupom');
        if (faixCupom) {
        const formButton = document.querySelector('.faixa-cupom-form button');
        var inputElement = document.getElementById("valorParaCopiar");
        if (inputElement) {
            var newValueInput = inputElement.value.replace(/^\/\//, '');
            inputElement.value = newValueInput

            if (formButton) {
            formButton.addEventListener("click", (e) => {
                e.preventDefault();

                inputElement.select();

                document.execCommand("copy");

                window.getSelection().removeAllRanges();

                alert("Valor copiado: " + newValueInput);
            });
            }
        }
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if(bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if(bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    } 

    waitForElementToExist('.faixa-cupom').then(element => {
        const faixCupom = document.querySelector('.faixa-cupom');
        if (faixCupom) {
        const formButton = document.querySelector('.faixa-cupom-form button');
            var inputElement = document.getElementById("valorParaCopiar");
            if (inputElement) {
                var newValueInput = inputElement.value.replace(/^\/\//, '');
                inputElement.value = newValueInput

                if (formButton) {
                formButton.addEventListener("click", (e) => {
                    e.preventDefault();

                    inputElement.select();

                    document.execCommand("copy");

                    window.getSelection().removeAllRanges();

                    alert("Valor copiado: " + newValueInput);
                });
                }
            }
        }
    });

    waitForElementToExist('.banner-instagram').then(element => {
        const banner = element.querySelector('.banner-instagram__list');

        if(banner) {
            $('.banner-instagram__list').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });

            if (window.innerWidth > 991) {
                setTimeout(() => {
                const listItems = document.querySelectorAll(".banner-instagram__list li");
              
                listItems.forEach(li => {
                  const height = li.offsetHeight; // Obtém a altura real do elemento
                  li.style.height = `${height}px`; // Define a altura como inline style
                });
            }, 500);
            }
        }
    });



    waitForElementToExist('.group-banner').then(element => {
        $('.group-banner-content').slick({
            arrows: false,
            infinite: false,
            autoplay: true,
            dots: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 2000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    

    waitForElementToExist('.home-product__list').then(element => {
        $('.product_list.normal-vitrine').slick({
            arrows: true,
            prevArrow: $(".count-2 .count-prev"),
            nextArrow: $(".count-2 .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                arrows: true,
                prevArrow: $(".count-3 .count-prev"),
                nextArrow: $(".count-3 .count-next"),
                dots: true,
                adaptiveHeight: true,
                autoplay: false,
                autoplaySpeed: 2500,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            prevArrow: $(".count .count-prev"),
            nextArrow: $(".count .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            prevArrow: $(".count .count-prev2"),
            nextArrow: $(".count .count-next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll:1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list3').slick({
            arrows: true,
            prevArrow: $(".count .count-prev3"),
            nextArrow: $(".count .count-next3"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list4').slick({
            arrows: true,
            prevArrow: $(".count .count-prev4"),
            nextArrow: $(".count .count-next4"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);
    
            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
    
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
    
                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function(i, c){
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);
    
                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                        '#carrousel-product-list3',
                        '#carrousel-product-list4',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');
                
                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }
    
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });
    
                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5, #carrousel-product-list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.banner-vitrine').then(element => {
        if (window.matchMedia("(min-width: 991px)").matches) {
            const bannerVitrineImg = document.querySelector('.banner-vitrine img');
            const containerProducts = document.querySelector('.banner-vitrine .banner-vitrine-content-products');
            if(bannerVitrineImg && containerProducts) {
                let productsHeight = containerProducts.getBoundingClientRect().height;
                bannerVitrineImg.style.height = productsHeight + 'px';
            }
        }
    });

    waitForElementToExist('.influencer').then(element => {
        $('.influencer-content-photos').slick({
            arrows: false,
            prevArrow: $(".group-title-arrows .arrow-prev"),
            nextArrow: $(".group-title-arrows .arrow-next"),
            infinite: false,
            autoplay: false,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                    }
                }
            ]
        });
    });

});